/**
 * 再生キューを組み立てるための共通ヘルパー
 *
 * キューは localStorage に永続化されるため、一度に入れるのは MAX_QUEUE_LENGTH 曲まで。
 */

import type { QueueTrackItem } from '@/api/type'
import type { MusicTrack } from '@/store/useMusicStore'

/** 一度にキューへ入れる最大曲数（全曲を入れると localStorage の容量上限に当たる） */
export const MAX_QUEUE_LENGTH = 100

/** 指定位置を含む最大 MAX_QUEUE_LENGTH 曲の窓を切り出す（末尾付近なら前にずらす） */
export const sliceQueueWindow = (tracks: QueueTrackItem[], index: number) => {
  const start = Math.max(0, Math.min(index, tracks.length - MAX_QUEUE_LENGTH))
  return { items: tracks.slice(start, start + MAX_QUEUE_LENGTH), startIndex: index - start }
}

/** 全体からランダムに最大 MAX_QUEUE_LENGTH 曲を選ぶ（Fisher-Yates を先頭 N 件だけ適用） */
export const pickRandomTracks = (tracks: QueueTrackItem[]): QueueTrackItem[] => {
  if (tracks.length <= MAX_QUEUE_LENGTH) return tracks

  const pool = [...tracks]
  for (let i = 0; i < MAX_QUEUE_LENGTH; i++) {
    const j = i + Math.floor(Math.random() * (pool.length - i))
    const tmp = pool[i]
    pool[i] = pool[j]
    pool[j] = tmp
  }
  return pool.slice(0, MAX_QUEUE_LENGTH)
}

/** API のキュー用トラックをプレイヤーのトラック形式に変換する */
export const toMusicTrack = (track: QueueTrackItem): MusicTrack => ({
  episodeId: track.episode_id,
  productId: track.product_id,
  title: track.title,
  artist: track.artist,
  artistTagId: track.artist_tag_id,
  album: track.album_title,
  thumbnail: track.thumbnail,
  duration: track.duration,
})
